import { createMobXStoreContext } from '@applied/utils/react_context/mobx_store';

import Snackbar from './page_snackbar';

export const { useSnackbar, createSnackbar, SnackbarProvider } = createMobXStoreContext(Snackbar, {
  mobXStoreName: 'snackbar',
  useConstructorParams: () => [],
  supportStrictInject: true,
});
